import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-7.5 -8 834.3125 207.59375",
          "style": {
            "maxWidth": "834.3125px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(-7.5, -8)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Implemented",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "191.59375",
                        "width": "818.3125",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(336.359375, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "161.59375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Proposal publication`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Checks LE-Publish",
                      "id": "L-Checks-Publish-0",
                      "d": "M189.094,104.297L193.177,104.214C197.26,104.13,205.427,103.964,212.794,103.88C220.16,103.797,226.727,103.797,230.01,103.797L233.294,103.797"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Publish LE-Monitor",
                      "id": "L-Publish-Monitor-0",
                      "d": "M378.219,103.797L382.385,103.797C386.552,103.797,394.885,103.797,402.419,103.863C409.952,103.929,416.686,104.061,420.053,104.127L423.42,104.193"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Monitor LE-ImplementedStatus",
                      "id": "L-Monitor-ImplementedStatus-0",
                      "d": "M630.219,104.297L634.302,104.214C638.385,104.13,646.552,103.964,653.919,103.88C661.285,103.797,667.852,103.797,671.135,103.797L674.419,103.797"
                    }}></path></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(110.796875, 103.796875)",
                      "id": "flowchart-Checks-0",
                      "className": "node default tertiary flowchart-label"
                    }}><polygon parentName="g" {...{
                        "style": {},
                        "transform": "translate(-69.796875,26.5)",
                        "className": "label-container",
                        "points": "0,0 139.59375,0 139.59375,-53 0,-53 0,0 -8,0 147.59375,0 147.59375,-53 -8,-53 -8,0"
                      }}></polygon><g parentName="g" {...{
                        "transform": "translate(-62.296875, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "124.59375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Schema checks `}<br parentName="span"></br>{` pass`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(308.40625, 103.796875)",
                      "id": "flowchart-Publish-1",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "139.625",
                        "y": "-26.5",
                        "x": "-69.8125",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-62.3125, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "124.625"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Publish schema `}<br parentName="span"></br>{` to GraphOS`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(528.96875, 103.796875)",
                      "id": "flowchart-Monitor-2",
                      "className": "node default tertiary flowchart-label"
                    }}><polygon parentName="g" {...{
                        "style": {},
                        "transform": "translate(-92.75,26.5)",
                        "className": "label-container",
                        "points": "0,0 185.5,0 185.5,-53 0,-53 0,0 -8,0 193.5,0 193.5,-53 -8,-53 -8,0"
                      }}></polygon><g parentName="g" {...{
                        "transform": "translate(-85.25, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "170.5"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`GraphOS matches `}<br parentName="span"></br>{` changes to proposals`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(740.515625, 103.796875)",
                      "id": "flowchart-ImplementedStatus-3",
                      "className": "node default secondary CircleSize50 flowchart-label"
                    }}><circle parentName="g" {...{
                        "height": "53",
                        "width": "121.59375",
                        "r": "60.796875",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></circle><g parentName="g" {...{
                        "transform": "translate(-53.296875, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "106.59375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Implemented `}<br parentName="span"></br>{` status`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      